import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ROLE_TYPES, type RoleType } from '@/constants/constants';

interface AccessTokenStoreState {
  accessToken: string;
  setAccessToken: (accessToken: string) => void;
}

interface RefreshTokenStoreState {
  refreshToken: string;
  setRefreshToken: (refreshToken: string) => void;
}

interface SelectedRoleStoreState {
  selectedRole: RoleType;
  isSbmRole: () => boolean;
  setSelectedRole: (selectedRole: RoleType) => void;
}

export const useAccessTokenStore = create(
  persist<AccessTokenStoreState>(
    (set) => ({
      accessToken: '',
      setAccessToken: (accessToken) => set({ accessToken }),
    }),
    {
      name: 'accessToken',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useRefreshTokenStore = create(
  persist<RefreshTokenStoreState>(
    (set) => ({
      refreshToken: '',
      setRefreshToken: (refreshToken) => set({ refreshToken }),
    }),
    {
      name: 'refreshToken',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useSelectedRoleStore = create(
  persist<SelectedRoleStoreState>(
    (set, get) => ({
      selectedRole: ROLE_TYPES.BM,
      isSbmRole: () => get().selectedRole === ROLE_TYPES.SBM,
      setSelectedRole: (selectedRole) => set({ selectedRole }),
    }),
    {
      name: 'selectedRole',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
